import { render, staticRenderFns } from "./ScenariosPage.vue?vue&type=template&id=05744c9c"
import script from "./ScenariosPage.vue?vue&type=script&lang=js"
export * from "./ScenariosPage.vue?vue&type=script&lang=js"
import style0 from "./ScenariosPage.vue?vue&type=style&index=0&id=05744c9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports